// extracted by mini-css-extract-plugin
export default {"container":"rateOfReturn_container__WkQzm","text":"rateOfReturn_text__jUQ8H"};